// Note: This file cannot have dependencies because
// it's used in after-build script (updatePages.ts)
export const metaTagsStaticProd = {
  mainTitle: 'Katana Perps',
  emptyTitle: "Katana Perps | Katana's Native Perpetuals DEX", // Set in index.html
  description:
    "Trade top markets with leverage and take part in Katana's chain revenue flywheel. Better liquidity. Better yield.",
};
